<template>
  <div class="content">
    <!-- 顶部横幅 -->
    <div class="banner-section">
      <img src="../assets/img/jyzx/jyzx.png" alt="" class="banner-image">
      <div class="banner-overlay">
        <div class="banner-text-wrapper">
<!--          <p class="banner-subtitle">TRADING RULES</p>-->
          <h1 class="banner-title">交易规则</h1>
        </div>
      </div>
    </div>

    <!-- 交易规则区域 -->
    <div class="rules-section">
      <!-- 白色内容盒子 -->
      <div class="content-wrapper">
        <!-- 标签页 -->
        <div class="tabs-container">
          <div class="tabs-wrapper">
            <div 
              v-for="(item, index) in tablists" 
              :key="index" 
              :class="['tab-item', { 'tab-active': tabis === item }]"
              @click="tabchange(item)"
            >
              {{ item }}
              <div class="tab-underline" v-if="tabis === item"></div>
            </div>
          </div>
        </div>

        <!-- 列表内容区域 -->
        <div class="list-content">
          <!-- 暂无数据 -->
          <div v-if="!falg" class="no-data">暂无数据</div>

          <!-- 规则列表 -->
          <div v-if="falg" class="rules-list-container">
          <el-table
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255, 255, 255, 0.9)"
            empty-text="暂无数据"
            height="100%"
            :header-cell-style="{ 
              backgroundColor: '#F9FAFB', 
              color: '#6B7280', 
              fontSize: '14px', 
              fontWeight: '500',
              borderBottom: '1px solid #E5E7EB',
              height: '56px'
            }"
            :cell-style="{ 
              borderBottom: '1px solid #F3F4F6',
              color: '#374151',
              fontSize: '14px',
              backgroundColor: '#FFFFFF',
              cursor: 'pointer'
            }"
            ref="gocarTable1"
            :data="tableData" 
            tooltip-effect="dark" 
            style="width: 100%; height: 400px;" 
            @select="gocarlistset"
            :default-sort="{ prop: 'date', order: 'descending' }"
            :row-class-name="tableRowClassName"
            @cell-click="handleCellClick"
          >
            <el-table-column label="标题" show-overflow-tooltip align="left" min-width="600">
              <template #default="scope">
                <div class="title-cell">
                  <svg class="title-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <rect x="3" y="2" width="10" height="12" rx="1" stroke="#3B82F6" stroke-width="1.5" fill="none"/>
                    <line x1="5" y1="5" x2="11" y2="5" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round"/>
                    <line x1="5" y1="8" x2="9" y2="8" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                  <span>{{ scope.row.name }}</span>
                  <el-tag v-if="scope.$index === 0" size="small" type="danger" effect="plain" class="new-tag">NEW</el-tag>
                </div>
              </template>
            </el-table-column>
       
            <el-table-column label="时间" align="center" width="200" show-overflow-tooltip>
              <template #default="scope">
                <div class="time-cell">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style="margin-right: 6px;">
                    <circle cx="7" cy="7" r="6" stroke="#9CA3AF" stroke-width="1.5"/>
                    <path d="M7 3.5V7L9.5 9.5" stroke="#9CA3AF" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                  <span>{{ scope.row.time }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          
          <!-- 分页 -->
          <div class="pagination-wrapper">
            <div class="pagination-info" v-if="listnum > 0">共 {{ listnum }} 条数据</div>
            <el-pagination
              v-if="listnum > 0"
              class="custom-pagination"
              :page-size="5"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              background
              layout="prev, pager, next"
              :total="listnum"
            />
          </div>
        </div>
        </div>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog
      title="河南科技成果与知识产权交易服务平台 交易规则(试行)"
      v-model="dialogVisible"
      width="70%"
      :modal="true"
      :before-close="handleClose"
      class="rules-dialog"
    >
      <div class="dialog-content">
        <div class="rules-text" v-html="rulesContent"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'jygzContent',
  components: {},
  data(){
    return{
      listnum:1,
      tableData:[{name:'河南科技成果与知识产权交易服务平台 交易规则(试行)',time:'2024-08-21'}],
      tablists:['交易规则','相关指引'],
      tabis:'交易规则',
      falg:true,
      dialogVisible: false,
      rulesContent: `
        <div class="chapter-section">
          <h2 class="chapter-title">第一章 总则</h2>
          <p class="article-item"><span class="article-number">第一条</span> 为规范在河南科技成果与知识产权交易服务平台（以下简称"科交平台"）进行的交易行为，保护交易各方的合法权益，维护交易秩序，根据《中华人民共和国促进科技成果转化法》《河南省促进科技成果转化条例》等有关规定，制定本规则。</p>
          <p class="article-item"><span class="article-number">第二条</span> 本规则适用于在科交平台进行的科技成果和知识产权交易，包括科技成果和知识产权的转让、许可、作价入股，技术开发、咨询等服务的购买，以及通过科交平台进行的其他交易行为。</p>
          <p class="article-item"><span class="article-number">第三条</span> 科交平台提供公开挂牌交易、非公开协议交易等进场交易方式。公开挂牌交易是指交易方在履行相关决策或审批程序后，通过科交平台发布交易信息，公开征集意向受让方的进场交易方式，按照受理交易申请、发布交易信息、登记受让意向、组织交易签约、结算交易资金、出具交易凭证等程序进行。非公开协议交易是指交易方在进场前已经达成交易并签订协议，科交平台对交易行为进行鉴证的交易方式。</p>
          <p class="article-item"><span class="article-number">第四条</span> 科交平台按照本规则对交易方提交的各项申请进行形式审核。科交平台不代为履行应当由交易方承担的任何义务，不为交易方提供任何形式的担保。交易方应当自行承担交易风险。</p>
          <p class="article-item"><span class="article-number">第五条</span> 交易方在科交平台从事交易，应当遵守法律法规、政策性文件的规定和科交平台的业务规则，遵循自愿平等、诚实信用和公平公正的原则，不得侵犯他人的合法权益，不得损害社会公共利益。涉及国有科技成果与知识产权交易的，应当符合国资监管规定。</p>
        </div>

        <div class="chapter-section">
          <h2 class="chapter-title">第二章 交易参与方</h2>
          <p class="article-item"><span class="article-number">第六条</span> 本规则所称交易参与方是指具有民事行为能力的自然人、法人或其他组织。交易参与方包括交易方和服务机构。</p>
          <p class="article-item"><span class="article-number">第七条</span> 交易方包括转让方、意向受让方和受让方。转让方是指向科交平台提出交易申请，对科技成果与知识产权拥有处置权的交易方。意向受让方是指向科交平台提出申请，有意向购买转让标的的交易方。受让方是指依法购得转让标的的交易方。</p>
          <p class="article-item"><span class="article-number">第八条</span> 转让方应具备项目所有权及处置权的主体资格，保证拟交易项目权属依法可以交易，并按照国家法律法规和相关政策规定，履行内部决策等相关程序。涉及国有科技成果与知识产权交易的，应当履行必要的审批备案流程。</p>
          <p class="article-item"><span class="article-number">第九条</span> 交易方应当按照科交平台的规定提交交易所需材料，并对所提交材料的真实性、准确性、完整性做出承诺，并承担相应责任。</p>
          <p class="article-item"><span class="article-number">第十条</span> 采取联合转让或联合受让方式的，各方应签订协议，明确各方的权利义务，并推举一方代表联合体各方办理转让或受让相关事宜。</p>
          <p class="article-item"><span class="article-number">第十一条</span> 服务机构是指向科交平台提出申请，经科交平台同意后，在科交平台为交易方提供专业服务的具有合法从业资格的专业机构，包括：（一）金融机构；（二）评估机构；（三）法律机构；（四）知识产权代理机构；（五）其他专业机构。</p>
        </div>

        <div class="chapter-section">
          <h2 class="chapter-title">第三章 公开挂牌交易</h2>
          <h3 class="section-subtitle">第一节 受理登记展示</h3>
          <p class="article-item"><span class="article-number">第十二条</span> 科技成果与知识产权在向科交平台正式申请公开挂牌交易前，可申请登记，进行信息发布展示。</p>
          <p class="article-item"><span class="article-number">第十三条</span> 科技成果与知识产权登记包括初始登记、变更登记、退出登记等。</p>
          <p class="article-item"><span class="article-number">第十四条</span> 初始登记是指科技成果与知识产权在科交平台的首次登记；变更登记是指因科技成果与知识产权信息变更而发生的登记；退出登记是指科技成果与知识产权发生有效期届满、有效期届满前无效或权利被撤销、转让方申请退出等情形时，在科交平台进行退出的登记。</p>
          <p class="article-item"><span class="article-number">第十五条</span> 科技成果与知识产权登记时，转让方应向科交平台提出登记申请，提交登记所需材料，并对所提交材料的真实性、完整性、准确性、有效性、合法性负责，不存在虚假记载、误导性陈述、泄露秘密、侵犯第三人权益等情形。</p>
          <p class="article-item"><span class="article-number">第十六条</span> 科交平台接到转让方的登记申请后，对申请材料进行形式审查，符合条件的在科交平台进行登记并进行信息发布展示。</p>
          <p class="article-item"><span class="article-number">第十七条</span> 科技成果与知识产权发生变更、退出情形的，科交平台对登记情况进行更新。</p>
        </div>

        <div class="chapter-section">
          <h3 class="section-subtitle">第二节 受理转让申请</h3>
          <p class="article-item"><span class="article-number">第十八条</span> 科技成果与知识产权在进场交易时，转让方应向科交平台提出科技成果与知识产权转让申请。申请进场交易之前转让方应按规定履行内部决策、审议程序，办理相关审批手续。</p>
          <p class="article-item"><span class="article-number">第十九条</span> 转让方应当向科交平台提交以下申请材料：（一）交易申请书；（二）转让方主体资格证明文件；（三）转让方内部决策文件或交易批准文件；（四）交易标的权属证明文件；（五）交易标的评估报告或其他定价依据；（六）交易标的涉及共有权或在交易标的上设置他项权利的，应当提供相关权利人同意交易的文件或对权利限制相关安排的说明文件；（七）科交平台要求提交的其他材料。转让方应对所提供材料的真实性、准确性、完整性、有效性、合法性负责，不存在虚假记载、误导性陈述、泄露秘密、侵犯第三人权益或重大遗漏等情形。</p>
        </div>

        <div class="chapter-section">
          <h2 class="chapter-title">第七章 附则</h2>
          <p class="article-item"><span class="article-number">第八十一条</span> 国家法律、法规及政府相关部门对交易有特别规定的，从其规定。</p>
          <p class="article-item"><span class="article-number">第八十二条</span> 本规则由河南省科教创新科技成果转化服务有限公司负责解释和修订。</p>
          <p class="article-item"><span class="article-number">第八十三条</span> 本规则自公布之日起施行。</p>
        </div>
      `
    }
  },
  mounted(){},
  methods:{
    handleCellClick() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handlecurrweipai(e){
      console.log(e);
    },
    tableRowClassName({rowIndex}) {
      console.log(rowIndex);
      if (rowIndex%2 ==0) {
        return 'warning-row';
      } else  {
        return 'success-row';
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    tabchange(item){
      this.tabis = item
      if(item=='交易规则'){
        this.falg = true
      }else{
        this.falg = false
      }
    }
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  min-height: calc(100vh - 196px);
  background: #F5F7FA;
  position: relative;
}

/* 顶部横幅 */
.banner-section {
  position: relative;
  width: 100%;
  height: 250px;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(10, 14, 26, 0.3) 0%, rgba(10, 14, 26, 0.6) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-text-wrapper {
  text-align: center;
}

.banner-subtitle {
  font-size: 14px;
  font-weight: 400;
  color: #51A2FF;
  letter-spacing: 2px;
  margin: 0 0 8px 0;
}

.banner-title {
  font-size: 36px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0;
  position: relative;
  padding-bottom: 20px;
}

.banner-title::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: #155DFC ;
  border-radius: 2px;
}

/* 交易规则区域 */
.rules-section {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -46px;
  z-index: 10;
  padding-bottom: 60px;
}

/* 白色内容盒子 */
.content-wrapper {
  width: 1200px;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* 标签页 */
.tabs-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}

.tabs-wrapper {
  display: flex;
  gap: 0;
  background: #F3F4F6;
  border-radius: 48px;
  padding: 4px;
}

.tab-item {
  position: relative;
  padding: 10px 32px;
  font-size: 15px;
  font-weight: 500;
  color: #6B7280;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 44px;
  white-space: nowrap;
}

.tab-item:hover {
  color: #3B82F6;
}

.tab-active {
  background: #3B82F6;
  color: #FFFFFF !important;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);
}

.tab-underline {
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 2px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 50%, rgba(255, 255, 255, 0) 100%);
  border-radius: 2px;
}

/* 列表内容区域 */
.list-content {
  width: 100%;
}

.no-data {
  text-align: center;
  padding: 60px 0;
  font-size: 16px;
  color: #9CA3AF;
}

/* 规则列表 */
.rules-list-container {
  width: 100%;
}

.title-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-icon {
  flex-shrink: 0;
}

.new-tag {
  margin-left: 8px;
}

.time-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6B7280;
}

/* 表格样式 */
:deep(.el-table) {
  background-color: #FFFFFF;
  color: #374151;
}

:deep(.el-table tr) {
  background-color: #FFFFFF;
}

:deep(.el-table .warning-row) {
  background: #FFFFFF;
}

:deep(.el-table .success-row) {
  background: #F9FAFB;
}

:deep(.el-table__inner-wrapper:before) {
  width: 0;
}

:deep(.el-table__body-wrapper) {
  background-color: #FFFFFF;
}

:deep(.el-table th.el-table__cell) {
  background-color: #F9FAFB;
  color: #6B7280;
  font-weight: 500;
}

:deep(.el-table td.el-table__cell) {
  color: #374151;
}

:deep(.el-table__row:hover > td) {
  background-color: #F9FAFB !important;
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #E5E7EB;
}

.pagination-info {
  font-size: 14px;
  color: #6B7280;
}

:deep(.custom-pagination.el-pagination.is-background .el-pager li:not(.is-disabled).is-active) {
  background-color: #3B82F6 !important;
  color: #FFFFFF !important;
  border-color: #3B82F6;
}

:deep(.custom-pagination.el-pagination.is-background .el-pager li:not(.disabled)) {
  background-color: #FFFFFF !important;
  color: #6B7280 !important;
  border: 1px solid #E5E7EB;
}

:deep(.custom-pagination.el-pagination.is-background .el-pager li:hover) {
  color: #3B82F6 !important;
  border-color: #3B82F6;
}

:deep(.custom-pagination.el-pagination.is-background .btn-next),
:deep(.custom-pagination.el-pagination.is-background .btn-prev) {
  background-color: #FFFFFF;
  color: #6B7280;
  border: 1px solid #E5E7EB;
}

:deep(.custom-pagination.el-pagination.is-background .btn-next:hover),
:deep(.custom-pagination.el-pagination.is-background .btn-prev:hover) {
  color: #3B82F6;
  border-color: #3B82F6;
}

:deep(.custom-pagination.el-pagination.is-background .btn-next:disabled),
:deep(.custom-pagination.el-pagination.is-background .btn-prev:disabled) {
  background-color: #F9FAFB;
  color: #D1D5DB;
  border-color: #E5E7EB;
}

/* 弹窗样式 */
:deep(.rules-dialog .el-dialog) {
  background: #FFFFFF;
  border-radius: 16px;
}

:deep(.rules-dialog .el-dialog__header) {
  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);
  padding: 24px 32px;
  border-radius: 16px 16px 0 0;
  margin: 0;
}

:deep(.rules-dialog .el-dialog__title) {
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 600;
}

:deep(.rules-dialog .el-dialog__headerbtn) {
  width: 36px;
  height: 36px;
  top: 24px;
  right: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

:deep(.rules-dialog .el-dialog__headerbtn:hover) {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

:deep(.rules-dialog .el-dialog__headerbtn .el-dialog__close) {
  color: #FFFFFF;
  font-size: 18px;
  font-weight: bold;
}

:deep(.rules-dialog .el-dialog__body) {
  padding: 32px;
  max-height: 600px;
  overflow-y: auto;
}

.dialog-content {
  color: #374151;
  font-size: 14px;
  line-height: 1.8;
}

.rules-text {
  color: #374151;
  font-size: 14px;
  line-height: 1.8;
}

.chapter-section {
  margin-bottom: 32px;
}

.chapter-section:last-child {
  margin-bottom: 0;
}

.chapter-title {
  font-size: 18px;
  font-weight: 700;
  color: #1F2937;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 3px solid #3B82F6;
  display: inline-block;
}

.section-subtitle {
  font-size: 15px;
  font-weight: 600;
  color: #3B82F6;
  margin: 16px 0 12px 0;
  padding-left: 12px;
  border-left: 3px solid #3B82F6;
}

.article-item {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  padding: 12px;
  background: #F9FAFB;
  border-radius: 8px;
  border-left: 4px solid #3B82F6;
  transition: all 0.3s;
}

.article-item:hover {
  background: #EFF6FF;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
}

.article-number {
  flex-shrink: 0;
  font-weight: 600;
  color: #3B82F6;
  min-width: 60px;
}

.article-text {
  flex: 1;
  color: #4B5563;
  line-height: 1.8;
  text-align: justify;
}
</style>
